/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbMobileRefineMenuFilterDimensions_filters = ReadonlyArray<{
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_filters">;
    readonly " $refType": "SbMobileRefineMenuFilterDimensions_filters";
}>;
export type SbMobileRefineMenuFilterDimensions_filters$data = SbMobileRefineMenuFilterDimensions_filters;
export type SbMobileRefineMenuFilterDimensions_filters$key = ReadonlyArray<{
    readonly " $data"?: SbMobileRefineMenuFilterDimensions_filters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterDimensions_filters">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbMobileRefineMenuFilterDimensions_filters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_filters"
    }
  ],
  "type": "SearchBrowseFilter",
  "abstractKey": null
};
(node as any).hash = 'f356903fe90b1a4ca17af752e1fb88a0';
export default node;
